import dayjs from 'dayjs';
import { CalendarEvent } from '../../../api/calendarEvent';

export type CalendarDay = {
  date: Date;
  isCurrentMonth: boolean;
  isToday: boolean;
  events: CalendarEvent[];
  dayNumber: number;
};

export const generateCalendarDays = (
  currentDate: Date,
  calendarEvents: CalendarEvent[] = [],
): CalendarDay[] => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDay = new Date(year, month, 1);

  const startDate = new Date(firstDay);
  startDate.setDate(firstDay.getDate() - firstDay.getDay());

  const calendarDays: CalendarDay[] = [];

  for (let i = 0; i < 42; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);

    const dayEvents = getEventsForDate(date, calendarEvents);

    calendarDays.push({
      date,
      isCurrentMonth: date.getMonth() === month,
      isToday: isSameDay(date, new Date()),
      events: dayEvents,
      dayNumber: date.getDate(),
    });
  }

  return calendarDays;
};

export const isPastDate = (date: Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dayDate = new Date(date);
  dayDate.setHours(0, 0, 0, 0);
  return dayDate < today;
};

export const getEventsForDate = (
  date: Date,
  calendarEvents: CalendarEvent[],
): CalendarEvent[] => {
  return calendarEvents.filter((event) => {
    const eventDate = new Date(
      event.date.year,
      event.date.month - 1,
      event.date.day,
    );
    return isSameDay(date, eventDate);
  });
};

export const isSameDay = (date1: Date, date2: Date): boolean => {
  return dayjs(date1).isSame(dayjs(date2), 'day');
};

export const getDayNames = (): string[] => {
  return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
};

export const formatMonthYear = (date: Date): string => {
  return dayjs(date).format('MMMM YYYY');
};

export const getRequiredWeeksForMonth = (currentDate: Date): number => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const startDate = new Date(firstDay);
  startDate.setDate(firstDay.getDate() - firstDay.getDay());

  const endDate = new Date(lastDay);
  const daysToAdd = 6 - lastDay.getDay();
  endDate.setDate(lastDay.getDate() + daysToAdd);

  const diffTime = endDate.getTime() - startDate.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const weeksNeeded = Math.ceil(diffDays / 7);

  return weeksNeeded;
};
